import { render, staticRenderFns } from "./garden7.vue?vue&type=template&id=7b6e1d09"
import script from "./garden7.vue?vue&type=script&lang=js"
export * from "./garden7.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports